// this is an autogenerated file from DesignSystem/TasksAssignee/Content/Content/SearchResult/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksAssignee_Content_Content_SearchResult($search_term: String!, $parent_company_id: uuid!) {
  vaxiom_persons_search(
    search_term: $search_term
    parent_company_id: $parent_company_id
    whole_parent_company: false
    employee_search: true
  ) {
    person: vaxiom_person {
      id
      first_name
      middle_name
      last_name
      public_user {
        id
      }
    }
  }
}

`